import React from 'react';
import {
  Button
} from '@material-ui/core';


//TODO: Add filters
const FilterDrawer = (
  {setOpenFilter}: IFilterDrawerProps
) => {
  return (
    <div className="px-4 pt-4 min-h-full-screen flex-column justify-between">
      <div>
        Filters will be added later...
      </div>
      <div className="flex items-center justify-between pb-4">
        <Button
          variant="contained"
          color="primary"
          fullWidth
          className="mr-2 uppercase"
          // onClick={handleApplyFilter}
          // disabled={isError}
        >
          Apply Filters
        </Button>
        <Button
          variant="outlined"
          fullWidth
          className="uppercase"
          onClick={() => {
            // setFilterConditions({});
            setOpenFilter(false);
          }}
        >
          Reset
        </Button>
      </div>
    </div>
  );
};

export default FilterDrawer;
